export class ValidationError extends Error {
  constructor(public messages: string[]) {
    super("Validation failed");
    this.name = "ValidationError";
  }
}
